import { create, invalidator, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import { createNlsMiddleware, keymap, lccstate, userstate } from '@holmescorp/lcc-state';
import { AssessViz } from './assess-viz';
import css from '../css/prepost-viz.m.css';
const nls = createNlsMiddleware('ditabook');
const factory = create({ theme, nls, lccstate, userstate, invalidator }).properties();
export const PrePostViz = factory(({ properties, middleware: { theme, nls, lccstate, userstate } }) => {
    const { whichtest } = properties();
    const { get, path } = userstate;
    const assessment = get(path('assessment'));
    const testresults = whichtest === 'practice' ? get(path('practice')) : get(path('posttest', 'tree'));
    const roots = lccstate.get(lccstate.path('ditaroots'));
    const { messages: { prepost_viz_score = '[ditabook] prepost_viz_score', prepost_viz_pretest = '[ditabook] prepost_viz_pretest' } } = nls();
    const themeCss = theme.classes(css);
    const root0 = roots[0];
    if (testresults[root0] === undefined || testresults[root0].data === undefined) {
        return v('div', { key: 'root', xqa: `viz`, classes: [themeCss.root] }, []);
    }
    const kids = roots.map((root) => {
        const { title = root, id = root } = keymap.get(root) || {};
        const assessmentTopic = assessment[id] ? assessment[id] : assessment[root];
        const assessBase = assessmentTopic.data.percent;
        const assess = assessBase > 1.0 ? assessBase / 100.0 : assessBase;
        const percentBase = testresults[id].data.percent;
        const percent = percentBase > 1.0 ? percentBase / 100.0 : percentBase;
        const xqa = `${whichtest}-viz ${id}`;
        return w(AssessViz, { xqa, title, percent, assess });
    });
    return v('div', { key: 'root', xqa: `viz`, classes: [themeCss.root] }, [
        v('div', { key: `scores`, role: 'list', xqa: `viz ${whichtest}`, classes: [themeCss.scoreblock] }, kids),
        v('div', { classes: [themeCss.legend] }, [
            v('div', { key: 'legend-score' }, [
                v('span', { classes: [themeCss.scoreIcon] }, [`\u25a0 `]),
                v('span', {}, [prepost_viz_score])
            ]),
            v('div', { key: 'legend-assess' }, [
                v('span', { classes: [themeCss.assessIcon] }, [`\u2666 `]),
                v('span', {}, [prepost_viz_pretest])
            ])
        ])
    ]);
});
